import { useEffect, useState } from "react"
import { useBulkCopyJobStatusQuery } from "./jobsQueries"
import { Button, Skeleton, Table } from "antd"
import { SelectedCustomerProperty } from "./JobTransferTable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faCircleX, faHourglass } from "@fortawesome/pro-solid-svg-icons"
import { green, red } from "@ant-design/colors"

type Props = {
  batchId: string
  selectedCustomerProperties: SelectedCustomerProperty[]
}

const BulkCopyStatus = ({batchId, selectedCustomerProperties}: Props) => {
  const [queryEnabled, setQueryEnabled] = useState(false)
  const bulkCopyJobStatusQuery = useBulkCopyJobStatusQuery(batchId, queryEnabled)
  const areAllJobsFinished = bulkCopyJobStatusQuery.data?.jobs.every(x => x.status === 'completed' || x.status === 'failed') ?? false

  useEffect(() => {
    setQueryEnabled(batchId !== '' && !areAllJobsFinished)
  }, [bulkCopyJobStatusQuery.data])

  const findMatchingCustomerProperty = (customerId: number, propertyId: number) => {
    return selectedCustomerProperties.find(x => x.customerId === customerId && x.propertyId === propertyId)
  }

  if(bulkCopyJobStatusQuery.isLoading) {
    return <Skeleton active/>
  }

  return <Table
    dataSource={bulkCopyJobStatusQuery.data?.jobs}
    rowKey={x => `${x.customerId}-${x.propertyId}`}
    pagination={{hideOnSinglePage: true}}
    columns={[
      {title: 'Customer', render: (_, item) => findMatchingCustomerProperty(item.customerId, item.propertyId)?.customer},
      {title: 'Property', render: (_, item) => findMatchingCustomerProperty(item.customerId, item.propertyId)?.property},
      {title: 'Status', render: (_, item) => <StatusIcon status={item.status} errorMessage={item.errorMessage}/>},
      {title: '', render: (_, item ) => 
        item.status === 'completed' ? <Button href={`#!/${item.jobUrl}`} target="_blank">Open Job</Button> : null},
    ]}
  />
}

export default BulkCopyStatus


const StatusIcon = ({status, errorMessage}: {status: string, errorMessage: string}) => {
  switch (status) {
    case 'completed':
      return <span><FontAwesomeIcon icon={faCircleCheck} color={green.primary}/> Completed</span>
    case 'failed':
      return <span><FontAwesomeIcon icon={faCircleX} color={red.primary}/> {errorMessage}</span>
    default:
      return <span><FontAwesomeIcon icon={faHourglass}/> Queued</span>
  }
}